export const managementConfigurationMessages = {
  en: {
    title: 'Config selection',
    btnConnectivityErrors: 'Connectivity errors',
    pickConfig: {
      btnFullConfig: 'Full Config',
      btnSanitizedConfig: 'Sanitized Config',
      columns: {
        downloadConfig: 'Download config',
      },
    },
    diff: {
      backButton: 'Back to config list',
      vs: 'vs.',
    },
    stepper: {
      firstConfig: 'First config',
      secondConfig: 'Second config',
      nothingSelected: 'Nothing selected',
      choose: 'Choose a config file from a table',
      lastChange: 'Last change:',
      nextButton: 'Next',
      showDiffButton: 'Show diff',
      startOverButton: 'Start over',
    },
  },
};
